var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudying(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -45 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222 391a25 25 0 0 1 0-50h269v50zm0 0",
    fill: "#ddf5ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M474 341v23c0 6-4 11-10 11H198c3 9 13 16 24 16h269v-50h-17zm0 0",
    fill: "#c1e9f4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222 391c-14 0-25-11-25-24-1-14 11-26 25-26h280c5 0 10-4 10-10v-11c0-5-5-10-10-10H222a56 56 0 0 0 0 113h280c5 0 10-5 10-11v-10c0-6-5-11-10-11zm0 0",
    fill: "#f33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M492 310v31h10c5 0 10-4 10-10v-11c0-5-5-10-10-10h-10zm0 0M492 423h10c5 0 10-5 10-11v-10c0-6-5-11-10-11h-10zm0 0",
    fill: "#e72d2d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M222 377v28c0 7 7 12 14 10l11-5 9 4c7 3 15-2 15-9v-28c0-6-5-11-11-11h-28c-6 0-10 5-10 11zm0 0",
    fill: "#ffd664"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222 166a25 25 0 0 1 0-50h269v50H222zm0 0",
    fill: "#ddf5ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M474 116v23c0 5-4 10-10 10H198c3 10 13 17 24 17h269v-50h-17zm0 0",
    fill: "#c1e9f4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M222 166c-14 0-25-11-25-25-1-14 11-25 25-25h280c5 0 10-5 10-11V95c0-6-5-11-10-11H222a56 56 0 1 0 0 113h280c5 0 10-5 10-10v-11c0-6-5-10-10-10H222zm0 0",
    fill: "#eb6a00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M492 84v32h10c5 0 10-5 10-11V95c0-6-5-11-10-11zm0 0M492 197h10c5 0 10-5 10-10v-11c0-6-5-10-10-10h-10zm0 0",
    fill: "#cd5e0c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M222 151v28c0 8 7 13 14 10l11-4 9 4c7 3 15-2 15-10v-28c0-6-5-10-11-10h-28c-6 0-10 4-10 10zm0 0",
    fill: "#ffd664"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M456 279a25 25 0 0 0 0-51H186v51zm0 0",
    fill: "#ddf5ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M456 228h-1l2 9c0 14-12 25-25 25H186v17h270a25 25 0 0 0 0-51zm0 0",
    fill: "#c1e9f4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M456 279c13 0 24-11 25-25 0-14-12-26-26-26H176c-6 0-11-4-11-10v-10c0-6 5-11 11-11h280a56 56 0 0 1 0 113H176c-6 0-11-5-11-11v-10c0-6 5-10 11-10h280zm0 0",
    fill: "#6a98ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M456 197h-18a56 56 0 0 1 0 113h18a56 56 0 1 0 0-113zm0 0",
    fill: "#3e80f6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M456 264v28c0 8-8 13-15 10l-10-5-10 4c-7 3-14-2-14-9v-28c0-6 4-10 10-10h28c6 0 11 4 11 10zm0 0",
    fill: "#ffd664"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96 204l-61 13L0 56c-1-6 3-12 8-13l41-9c6-1 11 3 13 8zm0 0",
    fill: "#6e9bff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44 35l32 148c1 5-3 11-9 12l-35 8 3 14 61-13L62 42c-2-5-7-9-13-8zm0 0",
    fill: "#3479f4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M132 379l-16 32c-2 6-10 8-15 3l-27-22-3-6-36-169 61-13 36 169v6zm0 0",
    fill: "#6e9bff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M81 207l34 159c2 9 1 18-3 26l-11 22c5 5 13 3 15-3l16-32v-6L96 204zm0 0",
    fill: "#3479f4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47 35l-37 8-5-27C3 10 7 5 13 4l16-4c6-1 11 3 12 8zm0 0",
    fill: "#ffd664"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26 1l8 37 13-3-6-27c-1-5-6-9-12-8zm0 0",
    fill: "#f9c646"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5 77l61-13 8 35-62 13zm0 0",
    fill: "#ffd664"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67l3 13c1 6-3 12-8 13l-36 7 2 12 62-13-8-35zm0 0",
    fill: "#f9c646"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58 182c-4 0-7-2-8-6L28 72a8 8 0 1 1 15-3l22 104a8 8 0 0 1-7 9zm0 0",
    fill: "#3b3b3b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudying);
export default __webpack_public_path__ + "static/media/studying.7ac55338af8cdbf2ab587d246207614b.svg";
export { ForwardRef as ReactComponent };